$(function(){
    $.fn.myBackgroundImage=function(options,images){
        //images:[{path:"",left,top}]
        var th=$(this),images_arr=[],i;
        for(i in images){
            if(_IMG_SERV &&  images[i].path.indexOf(_IMG_SERV)!=-1){
                images[i].path=images[i].path.replace(_IMG_SERV, "");
            }
            images_arr.push(images[i].path);
        }
        options=$.extend( {         
            widthImage:-1,
            heightImage:-1,
            showFullImageIndex:-1,
            
            widthCanv:-1,                
            heightCanv:-1,
            onEnd:function(){}
        }, options);
        if(options.widthImage==-1){
            options.widthImage=th.width();
        }
        if(options.heightImage==-1){
            options.heightImage=th.height();
        }
        //
        
        
        $("<div/>").one("myload",function(){
            var canvas = document.createElement('canvas'),ctx=canvas.getContext("2d");
            var i,bum,img,imagesObj=[],width=0,height=0,width_canvas=0,height_canvas=0;
            function prepareCrop(){
                if(options.showFullImageIndex==-1){
                    return {width:width_canvas,height:height_canvas,left:0,top:0};
                }
                var res={width:0,height:0,left:0,top:0};
                var img=imagesObj[options.showFullImageIndex],imgPos=images[options.showFullImageIndex];
                if(img.width/img.height>options.widthImage/options.heightImage){
                    res.width=img.width;
                    res.height=Math.round(Math.min(options.heightImage/options.widthImage*img.width,height_canvas));
                    res.left=imgPos.left;
                    res.top=Math.round(imgPos.top-(res.height-img.height)/2);
                }
                else{
                    res.height=img.height;
                    res.width=Math.round(Math.min(options.widthImage/options.heightImage*img.height,width_canvas));
                    res.top=Math.max(0,imgPos.top);
                    res.left=Math.round(imgPos.left-(res.width-img.width)/2);
                }
                if(res.left+res.width>width_canvas){
                    res.left=width_canvas-res.width;
                }
                if(res.top+res.height>height_canvas){
                    res.top=height_canvas-res.height;
                }
                res.left=Math.max(0,res.left);
                res.top=Math.max(0,res.top);
//                if(options.widthImage==534){
//                    debugArr(res);
//                }
                return res;
            }
            
            //compute all canvas size
            for(i in images){
                bum=images[i];
                img=new Image();
                img.src=bum['path'];
                width_canvas=Math.max(bum.left+img.width,width_canvas);
                height_canvas=Math.max(bum.top+img.height,height_canvas);
                imagesObj.push(img);
            }
            if(options.widthCanv!=-1){
                width_canvas=options.widthCanv;
            }
            if(options.heightCanv!=-1){
                height_canvas=options.heightCanv;
            }
            canvas.width=width_canvas;
            canvas.height=height_canvas;
            //draw images
            for(i in imagesObj){
                bum=images[i];
                ctx.drawImage(imagesObj[i], bum.left, bum.top);
            }
            var cropObj=prepareCrop();
            var sourceImage = ctx.getImageData(cropObj.left, cropObj.top, cropObj.width, cropObj.height);
            var imgLast=new Image;imgLast.src=sourceImage;
            var canvasPart=document.createElement('canvas'),ctxPart=canvasPart.getContext("2d");
            canvasPart.width=cropObj.width;
            canvasPart.height=cropObj.height;
            ctxPart.putImageData(sourceImage,0,0);
            
            var canvasLast=document.createElement('canvas'),ctxLast=canvasLast.getContext("2d");
            ctxPart.scale(0.1, 0.1);
            canvasLast.width=options.widthImage;
            canvasLast.height=options.heightImage;
            ctxLast.drawImage(canvasPart, 0, 0,options.widthImage,options.heightImage);
            
            
//            ctxOut.drawImage(imgLast, 0, 0);
//            ctxOut.putImageData(sourceImage,0,0);
//            th.css("background-image","url("+canvas.toDataURL('image/png')+")");canvas
            th.css("background-image","url("+canvasPart.toDataURL('image/png')+")");
//            th.css("background-image","url("+canvasLast.toDataURL('image/png')+")");
            
            options.onEnd();
            
        }).myLoad(images_arr);
        
        
        
        return this;
            
            
    } 
});
